// extracted by mini-css-extract-plugin
export var deleteModal = "_r3-0";